/* eslint-disable no-console */
import {useAuth0} from '@auth0/auth0-react';
// // import Hotjar from '@hotjar/browser';
import {Layout, message} from 'antd';
import {jwtDecode, JwtPayload} from 'jwt-decode';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import './App.scss';
import {
  Navigate,
  // Navigate,
  Route,
  Routes as RoutesDom,
  useNavigate
} from 'react-router-dom';

import NotFoundPage from './components/ErrorHandling/NotFoundComp/NotFound';
import FreeTrialFormModel from './components/FreeTrialFormModel/FreeTrialFormModel';
import MainHeader from './components/Header/MainHeader';
import Loader from './components/Loader/Loader';
import BottomMenu from './components/Menu/BottomMenu';
import LogoMenu from './components/Menu/LogoMenu';
import Menu from './components/Menu/Menu';
// import {isNavDisabled} from './components/Menu/Utils/isNavDisabled';
import ProductMenu from './components/Menu/ProductsMenu';
import CollapseSIdeNav from './components/Menu/Utils/CollapseSIdeNav';
import OnboardingFormModal from './components/OnboardingFormModal/OnboardingFormModal';
import PermissionCheckerHoc from './components/PermissionCheckerHoc/PermissionCheckHoc';
// import {getConfig} from './config';
import {PermissionEnum} from './constants/permissionsEnum';
import {Routes, allRoutes, subRoutes} from './constants/Routes';
import ActivityLog from './pages/activityLog/ActivityLog';
// import CommsManager from './pages/commsManager/CommsManager';
import AIDocumentManager from './pages/aiDocumentManager/AIDocumentManager';
import DataManagement from './pages/configurator/dataManagement/DataManagement';
import UserManagement from './pages/configurator/dataManagement/utils/userManagement/UserManagement';
import OrganizationFacility from './pages/configurator/orgFacility/OrganizationFacility';
import OrgHierarchy from './pages/configurator/orgHierarchy/Hierarchy/OrgHierarchy';
import ProcessFlow from './pages/configurator/orgHierarchy/Hierarchy/ProcessFlow';
// import OrgHierarchyAndProcessFlow from './pages/configurator/orgHierarchy/OrgHierarchyAndProcessFlow';
import ValueChainManagement from './pages/configurator/valueChainManagement/ValueChainManagement';
import Metrics from './pages/dashboard/Utils/Metrics/Metrics';
import StakeholderTracking from './pages/dashboard/Utils/StakeholderTracking/utils/StakeholderTracking';
import DataLineage from './pages/dataLineage/DataLineage';
import AuthError from './pages/error/AuthError';
import ESG from './pages/esgManager/ESG';
import GapAnalysis from './pages/esgManager/utils/gapAnalysis/GapAnalysisPage';
import PeerBenchmarking from './pages/esgManager/utils/PeerBenchmarking/PeerBenchmarking';
import Pillars from './pages/esgManager/utils/Pillars';
import Questions from './pages/esgManager/utils/Questions';
import ForgotPasswordScreen from './pages/forgotPassword/ForgotPasswordPage';
import GuestCompanySetUpWizard from './pages/HomeScreen/Components/GuestCompanySetUpWizard';
import TakeTour from './pages/HomeScreen/Components/TakeTour';
import TakeTourConfig from './pages/HomeScreen/Components/TakeTourConfiguration';
import HomeScreen from './pages/HomeScreen/HomeScreen';
import AssetTab from './pages/netZero/asset/AssetTab';
import Generalized from './pages/netZero/generalized/GeneralizedTab';
import ProductsTab from './pages/netZero/products/ProductsTab';
import SupplyChainTab from './pages/netZero/supplyChain/SupplyChainTab';
import TravelTab from './pages/netZero/travel/TravelTab';
import UtilityTab from './pages/netZero/utilities/UtilityTab';
import DisplayOCR from './pages/OCR/components/DisplayOCR';
import OcrMain from './pages/OCR/OcrMain';
import AssetManagement from './pages/orgManager/Utils/AssetManagement/AssetManagement';
// import FacilityAndOwner from './pages/orgManager/Utils/FacilityAndOwner/FacilityAndOwner';
import InfraProfile from './pages/orgManager/Utils/InfraStructureProfile/InfraProfile';
import Investment from './pages/orgManager/Utils/Investment/Investment';
// import OrgProfile from './pages/orgManager/Utils/OrgProfile/OrgProfile';
import Products from './pages/orgManager/Utils/Products/Products';
// import SupplierInfo from './pages/orgManager/Utils/SupplierInfo/SupplierInfo';
// import SetUp from './pages/setting/utils/SetUp';
// import UnitPreferences from './pages/setting/utils/UnitPreferences';
import PCFPage from './pages/PCF/PCFPage';
import PCFStudiesList from './pages/PCF/PCFStudiesList';
import GoalAndScope from './pages/PCF/utils/GoalAndScope';
import ImpactConfigurationPage from './pages/PCF/utils/ImpactConfigurationPage';
import LCIDataCollection from './pages/PCF/utils/LCIDataCollection';
import PCFReportExport from './pages/PCF/utils/PCFReportExport';
import ResultsInterpretationPage from './pages/PCF/utils/ResultsInterpretation';
import PlatformEducation from './pages/platformEducation/PlatformEducation';
import PricingPlansPage from './pages/pricingPlans/PricingPlansPage';
import ReportBuilder from './pages/reportBuilder/ReportBuilder';
import ReportEditor from './pages/reportBuilder/ReportEditor';
import ReportStudio from './pages/reportStudio/ReportStudio';
import AddRole from './pages/setting/utils/User Manager/Utils/AddRole';
import AddUser from './pages/setting/utils/User Manager/Utils/AddUser';
import RoleManager from './pages/setting/utils/User Manager/Utils/RoleManager';
import UserManager from './pages/setting/utils/User Manager/Utils/UserManager';
import SignUpScreen from './pages/signUp/SignUpPage';
import unitPreferenceJSON from './services/modules/JSON/unitPreference';
import activeFacilityCount from './services/modules/OM/activeFacilityCount';
import companyDetails from './services/modules/OM/companyDetails';
import subscriptionDetails from './services/modules/OM/subscriptionDetails';
import getUserFacility from './services/modules/User/getUserFacility';
import loginActivityDetail from './services/modules/User/loginActivityDetail';
import getUserDetails from './services/modules/User/meDetails';
import getTotalUserCount from './services/modules/User/totalUserCount';
import useCompanyStore from './store/companyStore/companyDetailsStore'; // accessModule
import usePlatformStore from './store/platformStore/platformStore';
import useUserStore from './store/userStore/userStore';
import {hasUserRole, UserRole} from './utils/commonFunctions';
import {removeSlash} from './utils/removeSlash';
import showMessage from './utils/showMessage';
// import {shouldBlockModuleAccess} from './utils/SubscriptionHelper';
import useIsTabActive from './utils/visibiltyChange';

// const config = getConfig();
interface JWTPayloadType extends JwtPayload {
  auth0Roles?: string[];
}
const App: React.FC = () => {
  const publicRoutes = ['/signup', '/forgotpassword', '/autherror'];
  const isPublicRoute = publicRoutes.includes(location.pathname.toLowerCase());

  const {
    userToken,
    setUserToken,
    setRoles,
    // userPermission,
    setAuth0Permissions
  } = useUserStore((state) => state);
  const productSelected = localStorage.getItem('product');
  // const loginData = JSON.parse(localStorage.getItem('dailyLogin') ?? '{}');
  const [product, setProduct] = useState(productSelected ?? '');
  const [showTour, setShowTour] = useState<boolean>(false);
  const [showTourConfig, setShowTourConfig] = useState<boolean>(false);
  // const [showMiniPlayer, setShowMiniPlayer] = useState<any>();
  // const [modalMiniPlayer, setModalMiniPlayer] = useState<any>();
  // const [dailyLogged, setDailyLogged] = useState<number>(loginData?.count);
  const [showGuestCompanySetUpWizard, setShowGuestCompanySetUpWizard] =
    useState<boolean>(false);
  const [showOnBoardingMessage, setShowOnBoardingMessage] =
    useState<boolean>(false);
  const [openKeys, setOpenKeys] = useState<string[]>([
    location.pathname === '/'
      ? removeSlash(Routes.HOME)
      : location.pathname.split('/')[1]
  ]);
  const navigate = useNavigate();

  const [, contextHolder] = message.useMessage();

  const [isAllLoaded, setIsAllLoaded] = useState(false);
  const [isExpiredShown, setIsExpiredShown] = useState(false);
  const isLoggedIn = localStorage.getItem('isLogged');
  const [collapsed, setCollapsed] = useState(false);
  const {Header, Sider, Content} = Layout;
  // const {userDetails} = useUserStore.getState();
  const [loadTourConfig, setLoadTourConfig] = useState(false);
  const [isPageStart, setIsPageStart] = useState<boolean>(true);
  const isOnBoarded = useCompanyStore((s) => s.companyDetails?.isOnBoarded);
  const openOnBoardingMessageModel = usePlatformStore(
    (s) => s.openOnBoardingMessageModel
  );

  const openOnFreeTrialMessageModel = usePlatformStore(
    (s) => s.openOnFreeTrialMessageModel
  );

  const {
    isLoading,
    error,
    isAuthenticated,
    getIdTokenClaims,
    loginWithRedirect,
    logout,
    user
  } = useAuth0();

  const {isTabVisible} = useIsTabActive();

  useEffect(() => {
    let interval: any;
    if (userToken && isTabVisible) {
      interval = setInterval(() => {
        const currentDate = moment().utc();
        const jwt = jwtDecode<JWTPayloadType>(userToken);
        if (jwt.exp !== undefined) {
          if (jwt.exp < currentDate.unix()) {
            if (!isExpiredShown) {
              showMessage(
                {
                  status: 'info',
                  message:
                    'Your session has expired please log in again \n logging out in 5 secs'
                },
                5
              );
            }
            setIsExpiredShown(true);
            setTimeout(() => {
              logout({logoutParams: {returnTo: window.location.origin}})
                .then(() => {})
                .catch(() => {});
              localStorage.removeItem('isLogged');
              localStorage.removeItem('token');
              localStorage.removeItem('product');
              setIsExpiredShown(false);
            }, 5000);
          }
        }
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  });

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getIdTokenClaims();
        const token = accessToken?.__raw;
        if (token) {
          localStorage.setItem('token', token);
          setUserToken(token);
          const jwt: any = jwtDecode(token);
          setAuth0Permissions(jwt.auth0Permission);
          if (jwt?.auth0Roles?.includes(UserRole.Company_Admin)) {
            const authPer = jwt?.auth0Roles?.filter((item: string) => {
              return !item.startsWith('access');
            });
            authPer.unshift(UserRole.Both_role);
            setRoles(authPer);
          } else {
            setRoles(jwt.auth0Roles);
          }
        }
      } catch (e: any) {
      } finally {
        Promise.all([getUserDetails(), unitPreferenceJSON()])
          .then(([userData]) => {
            if (userData?.stakeHolderType === 'Internal') {
              Promise.all([
                companyDetails(),
                subscriptionDetails(),
                getTotalUserCount(),
                activeFacilityCount(),
                !isLoggedIn && loginActivityDetail({user, isLogin: true}),
                getUserFacility()
              ])
                .then(() => {})
                .catch(() => {
                  if (!isExpiredShown) {
                    showMessage(
                      {
                        status: 'error',
                        message: 'Something went wrong please try again later.'
                      },
                      5
                    );
                  }
                  setIsExpiredShown(true);
                  setTimeout(() => {
                    logout({logoutParams: {returnTo: window.location.origin}})
                      .then(() => {})
                      .catch(() => {});
                    localStorage.removeItem('isLogged');
                    localStorage.removeItem('token');
                    setIsExpiredShown(false);
                  }, 5000);
                })
                .finally(() => {
                  setIsAllLoaded(true);
                  if (location.pathname === '/') {
                    navigate(Routes.HOME);
                  }
                });
            } else {
              if (!isExpiredShown) {
                showMessage(
                  {
                    status: 'error',
                    message: 'You are not authorized to access this platform'
                  },
                  5
                );
              }
              setIsExpiredShown(true);
              setTimeout(() => {
                logout({logoutParams: {returnTo: window.location.origin}})
                  .then(() => {})
                  .catch(() => {});
                localStorage.removeItem('isLogged');
                localStorage.removeItem('token');
                setIsExpiredShown(false);
              }, 5000);
            }
          })
          .catch(() => {
            if (!isExpiredShown) {
              showMessage(
                {
                  status: 'error',
                  message: 'Something went wrong please try again later.'
                },
                5
              );
            }
            setIsExpiredShown(true);
            setTimeout(() => {
              logout({logoutParams: {returnTo: window.location.origin}})
                .then(() => {})
                .catch(() => {});
              localStorage.removeItem('isLogged');
              localStorage.removeItem('token');
              setIsExpiredShown(false);
            }, 5000);
          });
      }
    };
    if (!userToken && isAuthenticated) {
      getUserMetadata()
        .catch(() => {})
        .finally(() => {
          // setIsAllLoaded(true);
        });
    }
  }, [isAuthenticated]);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     const loginCount = incrementDailyLoginCount();
  //     setDailyLogged(loginCount);
  //     setShowMiniPlayer(
  //       loginCount <= 3
  //         ? platformEduArray
  //             .flatMap((section) => section.videoData)
  //             .find((video) => video.route === location?.pathname)
  //         : null
  //     );
  //   }
  // }, [isAuthenticated]);
  // useEffect(() => {
  //   if (dailyLogged <= 3) {
  //     setShowMiniPlayer(
  //       platformEduArray
  //         .flatMap((section) => section.videoData)
  //         .find((video) => video.route === location?.pathname)
  //     );
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    if (isPageStart && isOnBoarded === false) {
      setShowGuestCompanySetUpWizard(true);
    } else if (isOnBoarded === false && openOnBoardingMessageModel) {
      setShowOnBoardingMessage(true);
    }
  }, [isOnBoarded, openOnBoardingMessageModel]);

  // useEffect(() => {
  //   Hotjar.init(config.hotjarSiteId, config.hotjarVersion, {
  //     debug: true
  //   });

  //   const userId = userDetails._id;
  //   const firstName = userDetails.firstName;
  //   const favoriteColor = 'blue';

  //   Hotjar.identify(userId, {
  //     first_name: firstName,
  //     color: favoriteColor
  //   });

  //   const actionName = 'Success';
  //   Hotjar.event(actionName);
  // }, []);

  useEffect(() => {
    if (!isLoading && !isPublicRoute) {
      if (isAuthenticated) {
        if (
          !localStorage.getItem('isLogged') ||
          localStorage.getItem('token')
        ) {
          localStorage.setItem('isLogged', 'true');
        } else {
          logout({logoutParams: {returnTo: window.location.pathname}})
            .then(() => {
              localStorage.removeItem('isLogged');
              localStorage.removeItem('token');
            })
            .catch(() => {});
        }
      } else {
        loginWithRedirect({
          appState: {
            returnTo: window.location.pathname
          }
        }).catch(() => {});
      }
    }
  }, [isLoading]);

  // const incrementDailyLoginCount = () => {
  //   const today = new Date().toISOString().split('T')[0];

  //   if (loginData.date === today) {
  //     loginData.count += 1;
  //   } else {
  //     loginData.date = today;
  //     loginData.count = 1;
  //   }

  //   localStorage.setItem('dailyLogin', JSON.stringify(loginData));

  //   return loginData.count;
  // };

  if (error) {
    return (
      <div>
        <div>Oops... {error.message}</div>
        <div>Please Login Again</div>
      </div>
    );
  }

  const logoPlace: React.CSSProperties = {
    alignSelf: collapsed ? 'center' : 'auto'
  };

  if (isPublicRoute) {
    return (
      <RoutesDom>
        <Route path="/signup" element={<SignUpScreen />} />
        <Route path="/forgotPassword" element={<ForgotPasswordScreen />} />
        <Route path="/autherror" element={<AuthError />} />
        {/* Add more public routes here */}
      </RoutesDom>
    );
  }

  return !isAllLoaded ? (
    <Loader isHome={true} />
  ) : isAuthenticated ? (
    <Layout className="main">
      {contextHolder}
      {location.pathname !== subRoutes.reportBuilderEditor && (
        <Sider
          className="sideNavContainer"
          collapsible={true}
          collapsed={collapsed}
          onCollapse={(value) => {
            setCollapsed(value);
          }}
          trigger={
            <CollapseSIdeNav arrowDirection={collapsed ? 'right' : 'left'} />
          }
        >
          <LogoMenu logoPlace={logoPlace} setProduct={setProduct} />
          <TakeTour
            visible={showTour}
            setVisible={setShowTour}
            onClose={(e) => {
              setOpenKeys([]);
              setTimeout(() => {
                if (!loadTourConfig) {
                  setLoadTourConfig(true);
                }
                setShowTourConfig(e);
              }, 300);
            }}
          />
          {loadTourConfig ? (
            <TakeTourConfig
              visible={showTourConfig}
              setVisible={setShowTourConfig}
            />
          ) : null}
          {showOnBoardingMessage ? (
            <OnboardingFormModal
              open={showOnBoardingMessage}
              onCancel={() => {
                setShowOnBoardingMessage(false);
                usePlatformStore
                  .getState()
                  .setOpenOnBoardingMessageModel(false);
              }}
              onFillForm={() => {
                usePlatformStore
                  .getState()
                  .setOpenOnBoardingMessageModel(false);
                setShowOnBoardingMessage(false);
                setShowGuestCompanySetUpWizard(true);
              }}
            />
          ) : null}

          {showGuestCompanySetUpWizard ? (
            <GuestCompanySetUpWizard
              visible={showGuestCompanySetUpWizard}
              setVisible={() => {
                useCompanyStore.getState().setOnBoarding(false);
                setShowGuestCompanySetUpWizard(false);
                setIsPageStart(false);
              }}
              allDone={setShowTour}
            />
          ) : null}

          {openOnFreeTrialMessageModel ? (
            <FreeTrialFormModel
              open={openOnFreeTrialMessageModel}
              onCancel={() => {
                usePlatformStore
                  .getState()
                  .setOpenOnFreeTrialMessageModel(false);
              }}
            />
          ) : null}

          <div style={{overflowY: 'scroll'}}>
            <Menu
              setOpenKeys={setOpenKeys}
              openKeys={openKeys}
              product={product}
              setProduct={setProduct}
            />
            <ProductMenu
              setOpenKeys={setOpenKeys}
              openKeys={openKeys}
              setProduct={setProduct}
              product={product}
            />
          </div>
          <BottomMenu
            setOpenKeys={setOpenKeys}
            openKeys={openKeys}
            product={product}
            menuCollapsed={collapsed}
          />
        </Sider>
      )}
      <Layout>
        {location.pathname !== subRoutes.reportBuilderEditor && (
          <Header
            className="header"
            style={{
              position: 'sticky',
              top: 0,
              zIndex: 1100
            }}
          >
            <MainHeader setProduct={setProduct} product={product} />
          </Header>
        )}
        <Content
          className={`${
            location.pathname !== subRoutes.reportBuilderEditor
              ? 'mainContent'
              : 'mainContent-editor'
          }`}
        >
          {/* {showMiniPlayer ? (
            <Flex className="MiniPlayerContainer" vertical>
              <CloseOutlined
                onClick={() => {
                  setShowMiniPlayer(null);
                }}
                className="closeButtonMiniPlayer"
              />
              <ReactVideoPlayer
                video={showMiniPlayer}
                isMiniPlayer={true}
                setShowMiniPlayer={setShowMiniPlayer}
                setModalMiniPlayer={setModalMiniPlayer}
              />
            </Flex>
          ) : (
            <FloatButton
              className="tipsFloatingButton"
              shape="square"
              icon={
                <QuestionCircleOutlined
                  style={{color: '#fff', strokeWidth: '1.5px'}}
                />
              }
              onClick={() => {
                setShowMiniPlayer(
                  platformEduArray
                    .flatMap((section) => section.videoData)
                    .find((video) => video.route === location?.pathname)
                );
              }}
              description="Tips"
            />
          )} */}
          {/* {modalMiniPlayer && (
            <ModalReactPlayer
              video={modalMiniPlayer}
              onClose={() => {
                setModalMiniPlayer(null);
              }}
            />
          )} */}
          <RoutesDom>
            <Route
              path="/"
              element={<Navigate to={allRoutes.HOME.HOME} replace />}
            />
            <Route
              path={Routes.PRICING_DETAILS}
              element={<PricingPlansPage />}
            ></Route>
            <Route
              path={Routes.HOME}
              element={
                <HomeScreen
                  setProduct={setProduct}
                  setShowTour={setShowTour}
                  setOpenKeys={setOpenKeys}
                />
              }
            ></Route>
            <Route path={`${Routes.DASHBOARD}`}>
              <Route
                index
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.DashboardMetrics}
                  >
                    <Metrics />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.metrics)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.DashboardMetrics}
                  >
                    <Metrics />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.stakeholderTracking)}
                element={<StakeholderTracking />}
              />
            </Route>
            <Route path={`${Routes.CONFIGURATOR}`}>
              <Route
                index
                element={
                  <PermissionCheckerHoc
                    permission={
                      PermissionEnum.ConfiguratorOrganisationFacilities
                    }
                  >
                    <OrganizationFacility />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.Organisation_Facility)}
                element={
                  <PermissionCheckerHoc
                    permission={
                      PermissionEnum.ConfiguratorOrganisationFacilities
                    }
                  >
                    <OrganizationFacility />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.Value_chain_management)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.ConfiguratorValueChainManagement}
                  >
                    <ValueChainManagement />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.org_and_process_flow)}
                element={
                  <PermissionCheckerHoc
                    permission={
                      PermissionEnum.ConfiguratorOrganisationHierarchy
                    }
                  >
                    <OrgHierarchy />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.process_flow)}
                element={<ProcessFlow />}
              />
              <Route
                path={removeSlash(subRoutes.data_management)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.ConfiguratorDataManagement}
                  >
                    <DataManagement />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.user_management)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.ConfiguratorUserManagement}
                  >
                    <UserManagement />
                  </PermissionCheckerHoc>
                }
              />
              <Route path={allRoutes.Configurator.userManager}>
                <Route
                  index
                  element={
                    <PermissionCheckerHoc
                      permission={PermissionEnum.ConfiguratorUserManagement}
                    >
                      <UserManager />
                    </PermissionCheckerHoc>
                  }
                />
                <Route
                  path={allRoutes.Configurator.addUser}
                  element={
                    <PermissionCheckerHoc
                      permission={PermissionEnum.ConfiguratorUserManagement}
                    >
                      <AddUser />
                    </PermissionCheckerHoc>
                  }
                />
                <Route
                  path={allRoutes.Configurator.updateUser}
                  element={
                    <PermissionCheckerHoc
                      permission={PermissionEnum.ConfiguratorUserManagement}
                    >
                      <AddUser />
                    </PermissionCheckerHoc>
                  }
                />
                <Route path={allRoutes.Configurator.roleManager}>
                  <Route
                    index
                    element={
                      <PermissionCheckerHoc
                        permission={PermissionEnum.ConfiguratorUserManagement}
                      >
                        <RoleManager />
                      </PermissionCheckerHoc>
                    }
                  />
                  <Route
                    path={allRoutes.Configurator.addRole}
                    element={
                      <PermissionCheckerHoc
                        permission={PermissionEnum.ConfiguratorUserManagement}
                      >
                        <AddRole />
                      </PermissionCheckerHoc>
                    }
                  />
                  <Route
                    path={allRoutes.Configurator.updateRole}
                    element={
                      <PermissionCheckerHoc
                        permission={PermissionEnum.ConfiguratorUserManagement}
                      >
                        <AddRole />
                      </PermissionCheckerHoc>
                    }
                  />
                </Route>
              </Route>
              <Route path={removeSlash(subRoutes.OCR)}>
                <Route index element={<OcrMain />} />
                <Route
                  element={<DisplayOCR />}
                  path={removeSlash(subRoutes.display_OCR)}
                />
              </Route>
            </Route>
            <Route path={Routes.ORG_MANAGER}>
              {/* <Route
                path={removeSlash(subRoutes.orgManager)}
                element={
                  isNavDisabled(userPermission?.OM.orgManager) ? (
                    <></>
                  ) : (
                    <OrgProfile />
                  )
                }
              />
              <Route
                path={removeSlash(subRoutes.facility)}
                element={
                  isNavDisabled(userPermission?.OM.facility) ? (
                    <></>
                  ) : (
                    <FacilityAndOwner />
                  )
                }
              />
              <Route
                path={removeSlash(subRoutes.supplierInfo)}
                element={
                  isNavDisabled(userPermission?.OM.supplier) ? (
                    <></>
                  ) : (
                    <SupplierInfo />
                  )
                }
              /> */}
              <Route
                path={removeSlash(subRoutes.infraProfile)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.OrgManagerInfrastructureProfile}
                  >
                    <InfraProfile />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.assetManagement)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.OrgManagerAssetManager}
                  >
                    <AssetManagement />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.investments)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.OrgManagerInvestment}
                  >
                    <Investment />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.products)}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.OrgManagerProduct}
                  >
                    <Products />
                  </PermissionCheckerHoc>
                }
              />
            </Route>
            <Route path={Routes.NET_ZERO}>
              <Route
                path={allRoutes.NZM.generalized}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.NZMGeneralized}
                  >
                    <Generalized />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={allRoutes.NZM.utilities}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.NZMUtilities}
                  >
                    <UtilityTab />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={allRoutes.NZM.supplyChain}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.NZMSupplyChain}
                  >
                    <SupplyChainTab />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={allRoutes.NZM.travel}
                element={
                  <PermissionCheckerHoc permission={PermissionEnum.NZMTravel}>
                    <TravelTab />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={allRoutes.NZM.asset}
                element={
                  <PermissionCheckerHoc permission={PermissionEnum.NZMAsset}>
                    <AssetTab />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={allRoutes.NZM.products}
                element={
                  <PermissionCheckerHoc permission={PermissionEnum.NZMProducts}>
                    <ProductsTab />
                  </PermissionCheckerHoc>
                }
              />
            </Route>
            <Route
              path={Routes.DATA_LINEAGE}
              element={
                <PermissionCheckerHoc
                  permission={
                    hasUserRole(UserRole.Company_Admin)
                      ? true
                      : PermissionEnum.DataLineage
                  }
                >
                  <DataLineage />
                </PermissionCheckerHoc>
              }
            />
            <Route path={Routes.ESG}>
              <Route path={removeSlash(subRoutes.framework)}>
                <Route
                  index
                  element={
                    <PermissionCheckerHoc permission={PermissionEnum.ESG}>
                      <ESG />
                    </PermissionCheckerHoc>
                  }
                />
                <Route
                  path=":framework"
                  element={
                    <PermissionCheckerHoc permission={PermissionEnum.ESG}>
                      <Pillars />
                    </PermissionCheckerHoc>
                  }
                />
                <Route
                  path=":framework/:pillar"
                  element={
                    <PermissionCheckerHoc permission={PermissionEnum.ESG}>
                      <Questions />
                    </PermissionCheckerHoc>
                  }
                />
              </Route>
              <Route
                path={removeSlash(subRoutes.peer_bechmarking)}
                element={
                  <PermissionCheckerHoc permission={PermissionEnum.ESG}>
                    <PeerBenchmarking />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.gap_analysis)}
                element={
                  <PermissionCheckerHoc permission={PermissionEnum.ESG}>
                    <GapAnalysis />
                  </PermissionCheckerHoc>
                }
              />
            </Route>

            <Route path={Routes.OCR}>
              <Route
                path={'main'}
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.AIDocumentManager}
                  >
                    <OcrMain />
                  </PermissionCheckerHoc>
                }
              />
              <Route
                element={
                  <PermissionCheckerHoc
                    permission={PermissionEnum.AIDocumentManager}
                  >
                    <DisplayOCR />
                  </PermissionCheckerHoc>
                }
                path={removeSlash(subRoutes.display_OCR)}
              />
            </Route>
            {/* <Route path={Routes.COMMS} element={<CommsManager />}>
              <Route
                path=":tabIndex"
                element={
                  isNavDisabled(userPermission?.comms) ? (
                    <></>
                  ) : (
                    <CommsManager />
                  )
                }
              />
            </Route> */}
            <Route
              path={Routes.PLATFORM_EDUCATION}
              element={
                <PermissionCheckerHoc
                  permission={
                    true
                    // !shouldBlockModuleAccess(accessModule.Platform_Education)
                  }
                >
                  <PlatformEducation />
                </PermissionCheckerHoc>
              }
            ></Route>
            <Route
              path={Routes.ACTIVITY_LOG}
              element={
                <PermissionCheckerHoc permission={PermissionEnum.ActivityLog}>
                  <ActivityLog />
                </PermissionCheckerHoc>
              }
            ></Route>
            <Route
              path={Routes.AI_DOCUMENT_MANAGER}
              element={
                <PermissionCheckerHoc
                  permission={PermissionEnum.AIDocumentManager}
                >
                  <AIDocumentManager />
                </PermissionCheckerHoc>
              }
            ></Route>
            <Route path={Routes.REPORT_STUDIO}>
              <Route
                index
                path={removeSlash(subRoutes.reports)}
                element={
                  // <PermissionCheckerHoc
                  //   permission={PermissionEnum.ReportStudio}
                  // >
                  <ReportStudio />
                  // </PermissionCheckerHoc>
                }
              />
              <Route
                path={removeSlash(subRoutes.reportBuilder)}
                element={
                  // <PermissionCheckerHoc
                  //   permission={PermissionEnum.ReportStudio}
                  // >
                  <ReportBuilder />
                  // </PermissionCheckerHoc>
                }
              ></Route>
            </Route>
            <Route
              path={subRoutes.reportBuilderEditor}
              element={<ReportEditor />}
            ></Route>
            <Route path={Routes.PCF}>
              <Route index element={<PCFPage />} />
              <Route
                path={allRoutes.PCF.studies}
                element={<PCFStudiesList />}
              />
              <Route
                path={`${allRoutes.PCF.goalAndScope}/:id?`}
                element={<GoalAndScope />}
              />
              <Route
                path={`${allRoutes.PCF.lciDataCollection}/:id?`}
                element={<LCIDataCollection />}
              />
              <Route
                path={`${allRoutes.PCF.impactConfiguration}/:id?`}
                element={<ImpactConfigurationPage />}
              />
              <Route
                path={`${allRoutes.PCF.resultsInterpretation}/:id?`}
                element={<ResultsInterpretationPage />}
              />
              <Route
                path={`${allRoutes.PCF.reportExport}/:id?`}
                element={<PCFReportExport />}
              />
            </Route>
            <Route path={Routes.SETTING}>
              {/* <Route
                path={allRoutes.setting.unitPreference}
                element={
                  isNavDisabled(userPermission?.setting.unitPreference) ? (
                    <></>
                  ) : (
                    <UnitPreferences />
                  )
                }
              /> */}
              {/* <Route path={allRoutes.setting.userManager}>
                <Route
                  index
                  element={
                    <PermissionCheckerHoc
                      permission={PermissionEnum.ConfiguratorUserManagement}
                    >
                      <UserManager />
                    </PermissionCheckerHoc>
                  }
                />
                <Route
                  path={allRoutes.setting.addUser}
                  element={
                    <PermissionCheckerHoc
                      permission={PermissionEnum.ConfiguratorUserManagement}
                    >
                      <AddUser />
                    </PermissionCheckerHoc>
                  }
                />
                <Route
                  path={allRoutes.setting.updateUser}
                  element={
                    <PermissionCheckerHoc
                      permission={PermissionEnum.ConfiguratorUserManagement}
                    >
                      <AddUser />
                    </PermissionCheckerHoc>
                  }
                />
                <Route path={allRoutes.setting.roleManager}>
                  <Route
                    index
                    element={
                      <PermissionCheckerHoc
                        permission={PermissionEnum.ConfiguratorUserManagement}
                      >
                        <RoleManager />
                      </PermissionCheckerHoc>
                    }
                  />
                  <Route
                    path={allRoutes.setting.addRole}
                    element={
                      <PermissionCheckerHoc
                        permission={PermissionEnum.ConfiguratorUserManagement}
                      >
                        <AddRole />
                      </PermissionCheckerHoc>
                    }
                  />
                  <Route
                    path={allRoutes.setting.updateRole}
                    element={
                      <PermissionCheckerHoc
                        permission={PermissionEnum.ConfiguratorUserManagement}
                      >
                        <AddRole />
                      </PermissionCheckerHoc>
                    }
                  />
                </Route>
              </Route> */}
              {/* <Route
                path={allRoutes.setting.setup}
                element={
                  isNavDisabled(userPermission?.setting.setup) ? (
                    <></>
                  ) : (
                    <SetUp />
                  )
                }
              /> */}
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </RoutesDom>
        </Content>
      </Layout>
    </Layout>
  ) : (
    <Loader />
  );
};

export default App;
